export class CostAndExpenseModel {
  public costAndExpenseHashId: string;
  public description: string;
  public createdBy: number;
  public reportedByPersonHashId: string = '';
  public reportedByPersonHashIdList: string[] = [];
  public reportedByName: string = '';
  public reportedByNameList: string[] = [];
  public costTypeHashId: string = '';
  public reportedDateTime: string
  public approvedAmountInVat: number;
  public reportedAmountInVat: number;

  public approvedAmountExVat: number;
  public reportedAmountExVat: number;

  public reportedVatPercentage: number;
  public approvedVatPercentage: number;

  public approvedByHashId: string;
  public invoiceHashId: string;
  public recipientOrganizationHashId: string = '';
  public recipientDriverHashId: string = '';
  public status: string;
  public invoiceStatus: string;
  public receiptPath: string;

  public costType: string;
  public approvedByName: string;
  public invoiceNumber: string;
  public chargeToName: string;

  public fromDateTime: string;
  public toDateTime: string;
  public statusList: string[];
  public isChecked: boolean;
  public isDeletable: boolean;

  public isCharge: boolean = true;
  public chargeToDriver: boolean = true;
  public reportedByDriver: boolean = true;
  public bookingHashId: string = "";

  public approvedAmountVat: number;
  public reportedVatAmount: number;

  public bookingReferenceID: string;

  public isEditable: boolean;
  public isDescCostTypeOnlyEdit: boolean = false;
  //public sharedVehicleDriverHashId:string;
  public sharedVehicleGroupDriverHashId: string='';
  public module: string;



}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/cost-expenses/models/cost-expense.model.ts